module.exports = __webpack_public_path__ + "../static/media/sm.8c19b48a.jpg";